import { handleResult } from '@/helpers/utils/functionality-utils';
import { userModule } from '@/module/userModule';
import ApiService, { type RequestOptions } from '@/services/apiService';
import type { MyAlarm } from '@/types/user/alarm-types';

export class AlarmsService {
  private userApiService: ApiService;
  constructor() {
    this.userApiService = new ApiService(userModule);
  }
  async getMyAlarms(data: RequestOptions['params']) {
    const response = await this.userApiService.get<MyAlarm[]>(
      `/api/v1/auth/alarms`,
      data,
    );
    return handleResult(response);
  }
}
